import { AddressDto } from "./AddressDto";

export class Address {
    private addressModel: AddressDto;

    public street: string | undefined = '';
    public zipCode: string | undefined = '';
    public town: string | undefined = '';

    constructor(address?: AddressDto) {
        this.addressModel = !!address ? address : new AddressDto();

        this.street = this.addressModel.street;
        this.zipCode = this.addressModel.zipCode;
        this.town = this.addressModel.town;
    }

    public Reset() {
        this.street = this.addressModel.street;
        this.zipCode = this.addressModel.zipCode;
        this.town = this.addressModel.town;
    }

    get HasChanges() {
        return this.addressModel.id == undefined
            || this.street != this.addressModel.street
            || this.zipCode != this.addressModel.zipCode
            || this.town != this.addressModel.town;
    }

    public GetModel() {
        var model = new AddressDto();

        model.id = this.addressModel.id;
        model.street = this.street;
        model.town = this.town;
        model.zipCode = this.zipCode;

        return model;
    }

    public SetValues(address: AddressDto) {
        this.addressModel = address;
        this.street = address.street;
        this.zipCode = address.zipCode;
        this.town = address.town;
    }
}
